var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-expansion-panel",
        _vm._l(_vm.parameters, function (p) {
          return _c(
            "v-expansion-panel-content",
            { key: p },
            [
              _c(
                "div",
                {
                  attrs: { slot: "header" },
                  on: {
                    click: function ($event) {
                      _vm.parameter = p
                    },
                  },
                  slot: "header",
                },
                [_vm._v(_vm._s(p))]
              ),
              _vm._v(" "),
              _c("v-select", {
                attrs: { items: _vm.stations },
                model: {
                  value: _vm.station,
                  callback: function ($$v) {
                    _vm.station = $$v
                  },
                  expression: "station",
                },
              }),
              _vm._v(" "),
              _c(
                "v-list",
                _vm._l(_vm.tsparams, function (t) {
                  return _c("v-list-tile", { key: t }, [_vm._v(_vm._s(t))])
                }),
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }